<template>
  <Component
    :content="section"
    :is="getComponent(section.flexLayout)"
    v-for="section in sections"
    :key="section.flexKey"
    :class="{ '--light': section.light }"
    :id="section.flexKey"
  />
</template>

<script>
import {
  ActivityTypesSection,
  CategoriesBannerSection,
  CategoriesSection,
  CategoryActivitiesSection,
  CTASection,
  DetailedCardsSection,
  IconCardsSection,
  ImageTextSection,
  LinksListSection,
  QuoteSection,
  TwoColumnsSection,
  UpcomingActivitiesSection,
  YoutubeVideoSection,
} from '@/components/sections/repeatable'

export default {
  name: 'SectionsRenderer',
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getComponent(layoutKey) {
      switch (layoutKey) {
        case 'activities-block':
          return CategoryActivitiesSection
        case 'activities-types-block':
          return ActivityTypesSection
        case 'cards-block':
          return DetailedCardsSection
        case 'categories-banner-block':
          return CategoriesBannerSection
        case 'categories-block':
          return CategoriesSection
        case 'cta-block':
          return CTASection
        case 'icon-cards-block':
          return IconCardsSection
        case 'image-text-block':
          return ImageTextSection
        case 'list-block':
          return LinksListSection
        case 'next-activities-block':
          return UpcomingActivitiesSection
        case 'quote-block':
          return QuoteSection
        case 'two-columns-block':
          return TwoColumnsSection
        case 'youtube-video-block':
          return YoutubeVideoSection
        default:
          return ''
      }
    },
  },
}
</script>
